var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entry-preview"},[_c('div',{staticClass:"entry-preview__buton-close",on:{"click":_vm.close}},[_c('base-icon',{attrs:{"icon":"cancel"}})],1),_c('div',{ref:"container",staticClass:"preview__container"},[_c('div',{staticClass:"preview__wrapper",style:({
        width: '100%',
        'max-width': ((_vm.iframe.innerWidth / _vm.iframeZoom) + "px"),
        height: '100%'//`${iframe.innerHeight / iframeZoom}px`
      })},[_c('iframe',{staticClass:"preview__iframe",style:({
          width: ((_vm.iframe.innerWidth * _vm.iframeZoom) + "px"),
          height: '100%',//`${iframe.innerHeight * iframeZoom}px`,
          transform: ("scale(" + _vm.iframeScale + ")"),
          zoom: _vm.iframeScale,
          overflow: _vm.hidden
        }),attrs:{"src":_vm.previewUrl,"scrolling":"yes","frameborder":"0"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }